import React from "react";
import { useGoogleLogin } from "@react-oauth/google";

import { BitmakerAPIClient } from "../../services/BitmakerApp";

import GoogleSignInButton from "./GoogleSignInButton";

interface Props {
    loginSuccess: (expires_in: number) => void;
}

export const GoogleSignIn: React.FC<Props> = ({ loginSuccess }: Props) => {
    const login = useGoogleLogin({
        onSuccess: (response) => {
            exchangeAuthorizationCode(response.code);
        },
        onError: () => {
            console.error("Login failed.");
        },
        flow: "auth-code",
    });

    const exchangeAuthorizationCode = (code: string) => {
        BitmakerAPIClient.post("/google-auth", { code }, (response) => {
            if (response.status === 200) {
                const expires_in = response.data.expires_in;
                loginSuccess(expires_in);
            } else {
                console.error("Error exchanging code:", response);
            }
        });
    };

    return <GoogleSignInButton onLogin={login} />;
};
